import React from 'react';
import { HardHat, Hammer } from 'lucide-react';
import { useTranslations } from 'next-intl';

export default function NoProjects() {
    const t = useTranslations('General')
    return (
        <main className="h-[600px] relative w-full bg-stone-10 flex flex-col items-center justify-center p-6 text-stone-800">
            <div className="absolute inset-0 z-0 opacity-10 pointer-events-none"
                style={{ backgroundImage: 'linear-gradient(#c0c0c0 1px, transparent 1px), linear-gradient(90deg, #c0c0c0 1px, transparent 1px)', backgroundSize: '50px 50px' }}
            />

            <div className="z-10 text-center max-w-2xl">
                <div className="mb-8 flex justify-center">
                    <div className="p-4 bg-white shadow-xl rounded-2xl border border-stone-200">
                        <Hammer size={48} strokeWidth={1.5} className="text-stone-700" />
                    </div>
                </div>

                <h1 className="text-5xl font-light tracking-tighter mb-4 uppercase">
                    {t('refining_the')} <span className="font-bold color-primary">{t('vision')}</span>
                </h1>

                <p className="text-stone-500 text-lg mb-12 leading-relaxed">
                   {t('under_curation')}
                   </p>
            </div>

            <footer className="absolute bottom-8 text-stone-400 text-sm font-mono uppercase tracking-widest">
                {t('check_other_filters')}
            </footer>
        </main>
    );
}